import { Area } from 'react-easy-crop';
import { IImageSize } from 'types/components/inputs/input.interface';

const createImage = (url: string): Promise<CanvasImageSource> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', error => reject(error));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = url;
  });

export const getCroppedImg = async (
  imageFile: File,
  crop: Area,
  height = 500,
  width = 500
): Promise<File> => {
  const originalMime = imageFile.type;
  const supportedFormats = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/webp',
  ];

  // Fallback if not supported
  const outputMime = supportedFormats.includes(originalMime)
    ? originalMime
    : 'image/jpg';

  // Set file extension based on mime
  const extension = outputMime.split('/')[1];
  const fileName = `${imageFile.name.replace(/\.[^/.]+$/, '')}.${
    extension === 'jpeg' ? 'jpg' : extension
  }`;

  const image = await createImage(URL.createObjectURL(imageFile));
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  console.log(imageFile);

  canvas.width = width;
  canvas.height = height;

  ctx?.drawImage(
    image,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    canvas.width,
    canvas.height
  );

  return new Promise((resolve, reject) =>
    canvas.toBlob(
      blob => {
        if (blob) {
          const file = new File([blob], fileName, { type: outputMime });
          resolve(file);
        }
      },
      outputMime,
      1
    )
  );
};

export const getImageSize = (height: number, width?: number): IImageSize => ({
  width: width ?? height,
  height,
});
